(() => {
  if (customElements.get('stx-cart')) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const ic = p => `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23272727' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E${p}%3C/svg%3E")`;
  const I_TRUCK = ic("%3Cpath d='M3 6h11v10H3z'/%3E%3Cpath d='M14 9h4l3 3v4h-7'/%3E%3Ccircle cx='7' cy='17.5' r='1.8'/%3E%3Ccircle cx='17' cy='17.5' r='1.8'/%3E");
  const I_SHIELD = ic("%3Cpath d='M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z'/%3E%3Cpath d='M9 12l2 2 4-4'/%3E");
  const I_LOCK = ic("%3Crect x='5' y='11' width='14' height='10' rx='1'/%3E%3Cpath d='M8 11V8a4 4 0 0 1 8 0v3'/%3E");
  const I_STAR = ic("%3Cpath d='M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z'/%3E");
  const PERK_CSS = `stx-cart .stxc__tr{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:20px 20px 0;padding:16px 0 0;border-top:1px solid #E3E3E3;list-style:none}
stx-cart .stxc__tr li{display:flex;flex-direction:column;align-items:center;gap:8px;text-align:center;font-size:12px;line-height:1.3;color:#404040}
stx-cart .stxc__tr li::before{content:"";width:22px;height:22px;background:var(--i) center/contain no-repeat}`;
  class StxCart extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      if (!document.getElementById('stxc-perks-css')) { const s = document.createElement('style'); s.id = 'stxc-perks-css'; s.textContent = PERK_CSS; document.head.appendChild(s); }
      const cfg = JSON.parse(this.querySelector('[data-cfg]').textContent);
      this.cfg = cfg;
      try { const f0 = new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency, maximumFractionDigits: 0 }), f2 = new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }); this.fmt = n => (Math.round(n) % 100 ? f2 : f0).format(n / 100); }
      catch (e) { this.fmt = n => '$' + (n / 100).toFixed(n % 100 ? 2 : 0); }
      this.panel = this.querySelector('[data-panel]');
      this.body = this.querySelector('[data-body]'); this.foot = this.querySelector('[data-foot]');
      this.addEventListener('click', e => this.onClick(e));
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.isOpen) this.close(); });
      window.addEventListener('stx:cart-open', e => this.open(e.detail && e.detail.cart));
      this.hijack();
      document.addEventListener('click', e => {
        const a = e.target.closest && e.target.closest('a[href$="/cart"]');
        if (a && !this.contains(a) && !e.metaKey && !e.ctrlKey) { e.preventDefault(); this.open(); }
      }, true);
    }
    hijack() {
      customElements.whenDefined('cart-drawer-component').then(() => {
        const C = customElements.get('cart-drawer-component'); if (!C || C.prototype._stx) return;
        const self = this;
        C.prototype._stx = true;
        C.prototype.showDialog = function () { self.open(); };
        C.prototype.open = function () { self.open(); };
      });
    }
    async fetchCart() { const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); return r.json(); }
    async open(cart) {
      if (!this.isOpen) {
        this.isOpen = true; this.hidden = false;
        this._lastFocus = document.activeElement;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(() => this.classList.add('is-open'));
        setTimeout(() => this.querySelector('[data-act="close"]').focus(), 50);
      }
      if (!cart) { this.body.setAttribute('aria-busy', 'true'); cart = await this.fetchCart(); }
      this.cart = cart; this.render();
      this.body.removeAttribute('aria-busy');
    }
    close() {
      this.isOpen = false; this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => { if (!this.isOpen) this.hidden = true; }, 360);
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
    }
    async post(url, body) { return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }
    async change(key, quantity) { this.busy(true); await this.done(await this.post('cart/change.js', { id: key, quantity })); }
    async upgrade(line) {
      const b = this.bundleFor(line); if (!b) return;
      this.anim = true; this.busy(true);
      await this.post('cart/change.js', { id: line.key, quantity: line.quantity - 1 });
      const r = await this.post('cart/add.js', { items: [{ id: b.id, quantity: 1 }] });
      this.flag(true);
      await this.done(r, true);
    }
    async downgrade(line) {
      const k = this.key(line.variant_title), sv = (this.cfg.standVariants || []).find(s => s.key === k) || (this.cfg.standVariants || [])[0]; if (!sv) return;
      this.anim = true; this.busy(true);
      await this.post('cart/change.js', { id: line.key, quantity: line.quantity - 1 });
      const r = await this.post('cart/add.js', { items: [{ id: sv.id, quantity: 1 }] });
      this.flag(false);
      await this.done(r, true);
    }
    flag(on) { try { on ? sessionStorage.setItem('stx_cart_up', '1') : sessionStorage.removeItem('stx_cart_up'); } catch (e) {} }
    flagged() { try { return sessionStorage.getItem('stx_cart_up') === '1'; } catch (e) { return false; } }
    async addStand() {
      const s = this.cfg.stand && this.cfg.stand[0]; if (!s) return;
      this.busy(true);
      await this.done(await this.post('cart/add.js', { items: [{ id: s.id, quantity: 1 }] }), true);
    }
    async done(r, refetch) {
      let cart = null;
      try { cart = refetch || !r.ok ? await this.fetchCart() : await r.json(); } catch (e) { cart = await this.fetchCart(); }
      this.cart = cart; this.render(); this.busy(false);
      document.querySelectorAll('[data-stx-cart-count]').forEach(n => { n.textContent = cart.item_count; });
      try { document.dispatchEvent(new CustomEvent('stx:cart-changed', { detail: { cart } })); } catch (e) {}
    }
    busy(on) { this.body.toggleAttribute('aria-busy', on); this.foot.toggleAttribute('aria-busy', on); }
    onClick(e) {
      const t = e.target.closest('[data-act]');
      if (!t) { if (e.target === this.querySelector('[data-scrim]')) this.close(); return; }
      const a = t.dataset.act, line = this.cart && this.cart.items.find(x => x.key === t.dataset.key);
      if (a === 'close') { e.preventDefault(); this.close(); }
      else if (a === 'inc' && line) this.change(line.key, line.quantity + 1);
      else if (a === 'dec' && line) this.change(line.key, line.quantity - 1);
      else if (a === 'remove' && line) this.change(line.key, 0);
      else if (a === 'upgrade' && line) { t.classList.add('is-on'); this.upgrade(line); }
      else if (a === 'downgrade' && line) { t.classList.remove('is-on'); this.downgrade(line); }
      else if (a === 'add-stand') this.addStand();
    }
    key(t) { return String(t || '').split('|')[0].trim().toLowerCase(); }
    bundleFor(line) {
      if (!this.cfg.bundle || line.product_id !== this.cfg.standId) return null;
      const k = this.key(line.variant_title);
      return this.cfg.bundle.find(b => b.key === k) || this.cfg.bundle[0];
    }
    esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    render() {
      const c = this.cart, cfg = this.cfg;
      this.querySelector('[data-count]').textContent = c.item_count ? `(${c.item_count})` : '';
      if (!c.item_count) {
        this.flag(false);
        this.foot.innerHTML = ''; this.body.innerHTML = `<div class="stxc__empty"><p>Your cart is empty.</p><a class="stxc__btn" href="${this.esc(cfg.standUrl)}">Shop the Model-X 2.0</a></div>`;
        return;
      }
      const elig = c.items.filter(i => cfg.eligible.includes(i.product_id)).reduce((s, i) => s + i.quantity, 0);
      const tiers = cfg.tiers;
      const curT = [...tiers].reverse().find(t => elig >= t.n) || { n: 0, pct: 0 };
      const next = tiers.find(t => t.n > elig && t.pct > 0);
      const prog = elig ? `<div class="stxc__prog">
          <div class="stxc__prog-t">${next ? `Add <b>${next.n - elig} more</b> for <b>${next.pct}% off</b> everything` : `<b>${curT.pct}% off</b> unlocked on every stand + bundle`}</div>
          <div class="stxc__bar">${tiers.map(t => `<span class="${elig >= t.n ? 'is-on' : ''}"><i>${t.n}${t.pct ? ' \u00b7 ' + t.pct + '% off' : ''}</i></span>`).join('')}</div>
        </div>` : '';
      const onlyStands = c.items.every(i => i.product_id === cfg.standId);
      const upLine = cfg.bundle && onlyStands ? c.items.find(i => i.product_id === cfg.standId) : null;
      const bLine = cfg.bundleId ? c.items.find(i => i.product_id === cfg.bundleId) : null;
      const onlyStandsPlusOneBundle = bLine && bLine.quantity === 1 && c.items.every(i => i.product_id === cfg.standId || i.product_id === cfg.bundleId);
      if (!bLine) this.flag(false);
      const lines = c.items.map(i => {
        const disc = i.original_line_price > i.final_line_price;
        return `<li class="stxc__line">
          <div class="stxc__img">${i.image ? `<img src="${this.esc(i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=200')}" alt="">` : ''}</div>
          <div class="stxc__info">
            <div class="stxc__name">${this.esc(i.product_title)}</div>
            ${i.variant_title ? `<div class="stxc__var">${this.esc(i.variant_title.split('|')[0].trim())}</div>` : ''}
            <div class="stxc__qrow">
              <div class="stxc__qty"><button type="button" data-act="dec" data-key="${i.key}" aria-label="Decrease">\u2212</button><span>${i.quantity}</span><button type="button" data-act="inc" data-key="${i.key}" aria-label="Increase">+</button></div>
              <button type="button" class="stxc__rm" data-act="remove" data-key="${i.key}">Remove</button>
            </div>
          </div>
          <div class="stxc__price">${disc ? `<s>${this.fmt(i.original_line_price)}</s>` : ''}<b>${this.fmt(i.final_line_price)}</b></div>
        </li>`;
      }).join('');
      const kb = +cfg.kbPrice || 0;
      const card = (on, act, key, sub, add) => {
        const pct = kb > add && add > 0 ? Math.round((kb - add) / kb * 100) : 0;
        return `<button type="button" role="switch" aria-checked="${on}" class="stxc__offer stxc__offer--b${on ? ' is-on' : ''}" data-act="${act}" data-key="${key}">
          <span class="stxc__chk" aria-hidden="true"></span>
          ${cfg.kbImg ? `<span class="stxc__offer-img"><img src="${this.esc(cfg.kbImg)}" alt="CMD-X keyboard and mouse"></span>` : ''}
          <span class="stxc__offer-t"><b>${this.esc(cfg.bundleTitle)}</b><span>${sub}</span></span>
          <span class="stxc__offer-p"><b>${on ? 'Added' : '+' + this.fmt(add)}</b>${!on && pct ? `<s>${this.fmt(kb)}</s><i>Save ${pct}%</i>` : ''}</span>
        </button>`;
      };
      let offer = '';
      if (bLine) {
        if (this.flagged() && onlyStandsPlusOneBundle) offer = card(true, 'downgrade', bLine.key, '<em>Added to 1 stand.</em> Tap to remove.', 0);
      } else if (upLine) {
        const b = this.bundleFor(upLine), add = Math.round((b.price - upLine.price) * (100 - curT.pct) / 100);
        offer = card(false, 'upgrade', upLine.key, 'Complete your setup with the CMD-X keyboard + mouse', add);
      }
      const save = c.items.reduce((s, i) => s + (i.original_line_price - i.final_line_price), 0) + (c.cart_level_discount_applications || []).reduce((s, d) => s + (d.total_allocated_amount || 0), 0);
      const freeShip = c.total_price >= (+cfg.freeShipMin || 9900);
      const trust = `<ul class="stxc__tr" aria-label="Why order from STXND">
          <li style='--i:${I_STAR}'>Trusted by 75,000+</li>
          <li style='--i:${freeShip ? I_TRUCK : I_SHIELD}'>${freeShip ? 'Free shipping' : '60-day guarantee'}</li>
          <li style='--i:${freeShip ? I_SHIELD : I_LOCK}'>${freeShip ? '60-day guarantee' : 'Secure checkout'}</li>
        </ul>`;
      this.body.innerHTML = `${prog}<ul class="stxc__lines">${lines}</ul>${offer}${trust}`;
      if (this.anim) { this.anim = false; const o = this.body.querySelector('.stxc__offer'); if (o) { o.classList.add('stxc-anim'); setTimeout(() => o.classList.remove('stxc-anim'), 1000); } }
      this.foot.innerHTML = `
          ${save > 0 ? `<div class="stxc__row"><span>You save</span><b>\u2212${this.fmt(save)}</b></div>` : ''}
          <div class="stxc__row stxc__row--total"><span>Total</span><b>${this.fmt(c.total_price)}</b></div>
          <a class="stxc__btn" href="${root}checkout">Checkout</a>`;
    }
  }
  customElements.define('stx-cart', StxCart);
})();
